export default {"src":"/statics/ecommerce/_next/static/media/icon-indice-reparation.3cc829c8.svg","height":57,"width":57,"blurWidth":0,"blurHeight":0};